export default __webpack_public_path__ + "static/media/appendix4.b7bc7152.jpg";